import { BrandAPIService } from "./brand";
import api from "..";

export default new BrandAPIService(api);
